import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EventTrackingValueWithSource } from '../../../../../../cross-team-shared/misc-utils';
import { settingsStoreToken } from '../../../../../../cross-team-shared/state/setting-state';
import { SettingsService } from '../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { inspectModeIcon } from '../../../../../shared/icons/toolbars/inspect-icon';
import { RootKeyboardShortcutService } from '../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Component({
  selector: 'h3-inspect-button',
  templateUrl: './inspect-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InspectButtonComponent {
  private readonly rootKeyboardShortcutService = inject(
    RootKeyboardShortcutService,
  );
  inspectMode$ = inject(settingsStoreToken)('inspectMode').$;
  toggleInspectModeTooltip =
    'Inspect' +
    this.rootKeyboardShortcutService.tooltipSuffix('toggleInspectMode');
  inspectModeIcon = inspectModeIcon;

  private settingsService = inject(SettingsService);

  toggleInspectMode(
    eventTrackingValueWithSource: EventTrackingValueWithSource,
  ) {
    this.settingsService.toggleInspectMode(eventTrackingValueWithSource);
  }
}
